export default __webpack_public_path__ + "static/media/arrow.b18b8bc1.svg";